import 'aos/dist/aos.css';

window.$ = jQuery;

import BannerSlider from './components/Banner-slider';
import Menu from './components/Menu';
import Carousel from './components/Carousel';
import Animations from './components/Animations';
import LazyLoad from 'vanilla-lazyload/dist/lazyload.js';
import Navigation from './components/Navigation';
import Modal from './components/Modal';
// import new_map from './components/Map';
import Radios from './components/Radios';
import Appeals from './components/Appeals';
import Header from './components/Header';

{
  Animations();
  Modal();
  Radios();
}

{
  let bannerSlider = document.querySelector('.banner-slider');
  let CarouselSection = document.querySelector('.carousel');
  let ACFmap = document.querySelector('.acf-map');
  let AppealsBar = document.querySelector('.fundraising-bar');
  let nav = document.querySelector('.main-menu ');
  let mobileMenu = document.querySelector('.header__mobileMenuTrigger');

  new LazyLoad({
      elements_selector: ".lazy"
  });

  if (typeof mobileMenu != "undefined" && mobileMenu != null) {
    Menu();
  }

  if (typeof nav != "undefined" && nav != null) {
    Navigation();
    Header();
  }

  if (typeof bannerSlider != "undefined" && bannerSlider != null) {
    BannerSlider();
  }

  if (typeof CarouselSection != "undefined" && CarouselSection != null) {
    Carousel()
  }

  if (typeof ACFmap != "undefined" && ACFmap != null) {
    new_map();
  }

  if (typeof AppealsBar != "undefined" && AppealsBar != null) {
    Appeals();
  }

}




// WEBPACK FOOTER //
// ./src/js/app/index.js